import { getDeviceType } from '@/configs/responsive.config';
import { useResponsiveStoreActions } from '@/stores/responsive.store';
import { useEffect } from 'react';

const useResponsive = () => {
  const { setDimensions, setDeviceType, setPlatform } = useResponsiveStoreActions();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const ua = navigator.userAgent;

      setDeviceType(getDeviceType(width));
      setDimensions({ width, height });
      setPlatform({ ua, width });
    };

    handleResize(); // initialize on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setDimensions, setDeviceType, setPlatform]);

  return null;
};

export default useResponsive;
